export const libroDevueltoObject = {
    id_libro:          null,
    id_curso_escolar:  null,
    fecha:             null,
    cantidad_devuelta: null,
}